// ================================
// Created : 27.12.2565 use in..
// - LabPrintView.vue
// - LabPrint2Dtl
// ================================
export default {
  getHighLowSign (row) {
    if (row.ValueType === '0' || (row.ValueType === 0)) {
      let resultStr = ''
      resultStr = row.Result.replace(/[,]/g, '') // เอา , ออก(ถ้ามี)
      // --------------------------------- //
      // ใช้ Min/Max/Normal แยกตามชายหรือหญิง
      if (row.MinMaxType === '1' || row.MinMaxType === 1) {
        if (row.Sex === '1' || row.Sex === 1) {
          // MALE ชาย
          if (row.MinValue !== '' && row.MaximumValue !== '') {
            if (parseFloat(resultStr) < parseFloat(row.MinValue)) {
              return 'L'
            } else if (parseFloat(resultStr) > parseFloat(row.MaximumValue)) {
              return 'H'
            }
          } else { return '' }
        } else if (row.Sex === '2' || row.Sex === 2) {
          // FEMALE หญิง
          if (row.MinValue2 !== '' && row.MaximumValue2 !== '') {
            if (parseFloat(resultStr) < parseFloat(row.MinValue2)) {
              return 'L'
            } else if (parseFloat(resultStr) > parseFloat(row.MaximumValue2)) {
              return 'H'
            }
          } else { return '' }
        }
      } else {
        // ใช่ Min/Max/Normal เหมือนกันทั้งชายและหญิง
        if (row.MinValue !== '' && row.MaximumValue !== '') {
          if (parseFloat(resultStr) < parseFloat(row.MinValue)) {
            return 'L'
          } else if (parseFloat(resultStr) > parseFloat(row.MaximumValue)) {
            return 'H'
          }
        } else { return '' }
      }
    } else {
      return ''
    }
  }
}
